/* =========================================================================
   Floating "+" cursor that follows the mouse over product images.
   - Smoothly lerps toward the pointer for fluid premium motion
   - Hides the default cursor on the image
   - Fades + scales in on enter, out on leave
   - Skips touch devices (no hover concept)
   ========================================================================= */
/* Ensure every desktop product gallery image has .bls__zoom-image
   so clicking opens the PhotoSwipe lightbox (regardless of theme setting) */
(function () {
  if (window.__blsZoomImageAutoInit) return;
  window.__blsZoomImageAutoInit = true;
  function attach() {
    var imgs = document.querySelectorAll(
      '.bls__template-main-product .gallery-img.image,' +
      ' .bls__template-main-product .bls__zoom-hover .gallery-img.image'
    );
    imgs.forEach(function (el) {
      el.classList.add('bls__zoom-image');
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attach);
  } else {
    attach();
  }
})();

(function () {
  if (window.__blsProductCursorInit) return;
  window.__blsProductCursorInit = true;

  // Touch / no-hover devices: do nothing
  if (
    !window.matchMedia ||
    !window.matchMedia('(hover: hover) and (pointer: fine)').matches
  ) return;

  var HOVER_SELECTOR =
    '.bls__template-main-product .gallery-img.image,' +
    ' .bls__template-main-product .bls__zoom-image,' +
    ' .bls__template-main-product .bls__zoom-hover';

  // Skip these inner media types
  function isImageHover(el) {
    if (!el) return false;
    if (
      el.classList.contains('video') ||
      el.classList.contains('external_video') ||
      el.classList.contains('model') ||
      el.classList.contains('image-360')
    ) return false;
    return true;
  }

  var cursor = document.createElement('div');
  cursor.className = 'bls__product-cursor';
  cursor.setAttribute('aria-hidden', 'true');
  cursor.innerHTML =
    '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<path d="M9 4v10M4 9h10" stroke="#1a1a1a" stroke-width="1.6" stroke-linecap="round"/>' +
    '</svg>';
  document.body.appendChild(cursor);

  var targetX = 0, targetY = 0;     // where we want the cursor to be
  var currentX = 0, currentY = 0;   // where it actually is (lerped)
  var visible = false;
  var rafId = null;

  // Lerp factor — 0..1, higher = snappier, lower = lazier
  var SMOOTHING = 0.18;

  function tick() {
    currentX += (targetX - currentX) * SMOOTHING;
    currentY += (targetY - currentY) * SMOOTHING;
    cursor.style.transform =
      'translate3d(' + currentX + 'px,' + currentY + 'px,0) translate(-50%, -50%)' +
      (visible ? ' scale(1)' : ' scale(0.6)');
    rafId = requestAnimationFrame(tick);
  }

  function show(x, y) {
    targetX = x;
    targetY = y;
    if (!visible) {
      // Snap on first show to avoid the cursor flying in from corner
      currentX = x;
      currentY = y;
      visible = true;
      cursor.classList.add('is-visible');
    }
    if (rafId === null) tick();
  }

  function hide() {
    visible = false;
    cursor.classList.remove('is-visible');
  }

  function isPhotoswipeOpen() {
    return !!document.querySelector('.pswp');
  }

  document.addEventListener('mousemove', function (e) {
    // Hard guard: never show cursor while the fullscreen gallery is open
    if (isPhotoswipeOpen()) {
      if (visible) hide();
      cursor.style.display = 'none';
      return;
    }
    var target = e.target.closest(HOVER_SELECTOR);
    if (target && isImageHover(target)) {
      show(e.clientX, e.clientY);
    } else if (visible) {
      hide();
    }
  }, { passive: true });

  document.addEventListener('mouseleave', hide);
  window.addEventListener('blur', hide);

  // Toggle visibility via display:none when PhotoSwipe is open/closed
  function sync() {
    var open = isPhotoswipeOpen();
    document.documentElement.classList.toggle('pswp-open', open);
    if (open) {
      hide();
      cursor.style.display = 'none';
    } else {
      cursor.style.display = '';
    }
  }
  if ('MutationObserver' in window) {
    new MutationObserver(sync).observe(document.body, {
      childList: true,
      subtree: false
    });
  }
})();
